import { useCallback, useEffect, useState } from "react";
import { deviceApi } from "../../infrastructure/deviceApi";
import type { Product } from "../../domain/types";

/**
 * Catálogo visible para la TERMINAL (solo lectura).
 *
 * En v2 el alta/edición de productos es del manager (JWT) y vive en /admin/catalogo: una
 * terminal de mostrador no puede modificar el catálogo del comercio. Por eso este hook ya
 * no expone create/update/remove — no es una simplificación, es el modelo de permisos.
 *
 * `price_mxn` viaja como string (Decimal del backend) y se convierte a número acá, en el
 * borde. La UI hace su aritmética en números, pero NUNCA manda un precio calculado: al
 * cobrar se envía `product_id` + `qty` y el backend recalcula con Decimal.
 */
export function useProducts() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await deviceApi.products.list();
      setProducts(
        data
          .filter((p) => p.active)
          .map((p) => ({
            id: p.id,
            name: p.name,
            price_mxn: Number(p.price_mxn),
            active: p.active,
            created_at: "",
            updated_at: "",
          }))
      );
    } catch (e) {
      setError(e instanceof Error ? e.message : "Error cargando el catálogo");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { products, loading, error, refresh };
}
